<template>
<div>
    <page-title-bar></page-title-bar>
    <v-container fluid grid-list-xl pt-0>
        <page-tool-bar
            :loading="loader"
            show_search
            show_building
            show_date_start
            show_date_end
            :search.sync="search"
            :chosen_building.sync="chosen_building"
            :date_start.sync="date_start"
            :date_end.sync="date_end"
        >
            <v-flex shrink>
                <div class="text-right">
                    <v-btn @click="exportCSV" color="green" class="white--text">XUẤT EXCEL</v-btn>
                    <v-btn
                        :disabled="loader"
                        @click="print_table = true"
                        color="primary"
                    >
                        <v-icon small left>print</v-icon>
                        In danh sách
                    </v-btn>
                    <export-csv-button
                        :trigger="export_csv.trigger"
                        :title="export_csv.title"
                        :rows="export_csv.rows"
                    ></export-csv-button>
                </div>
            </v-flex>
        </page-tool-bar>
        <v-layout row wrap justify-center>
            <v-flex xs12>
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        :rows-per-page-items="rowPerPage"
                        :search="search"
                        :loading="loader"
                        disable-initial-sort
                    >
                        <template #headers="props">
                            <tr>
                                <th :class="`text-xs-${header.align} fw-bold`" v-for="header in props.headers" :key="header.text">
                                    {{ header.text }}
                                </th>
                            </tr>
                        </template>
                        <template #items="props">
                            <!-- <td class="text-center">{{ props.item.show_room_id ? props.item.room_id : "" }}</td> -->
                            <td class="text-center">{{ props.item.room_id }}</td>
                            <!-- <td class="text-center">{{ props.item.customer_id }}</td> -->
                            <td class="text-left text-no-wrap">{{ props.item.name }}</td>
                            <td class="text-center">{{ props.item.phone }}</td>
                            <td class="text-left">{{ props.item.motorbike }}</td>
                            <td class="text-center">{{ props.item.bike ?  'Có' : '' }}</td>
                            <td class="text-center">{{ props.item.is_wm ?  'Có' : '' }}</td>
                            <td class="text-center text-no-wrap">{{ props.item.date_in | formatTimeServer}}</td>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>

    <print-portal layout="portrait" :open="print_table" @close="print_table = false">
        <print-bang-khach-hang :items="items"></print-bang-khach-hang>
    </print-portal>
</div>
</template>

<script>
import api from '../../api'
import { buildParamQuery, formatTimeServer } from '../../helpers/helpers.js'
import moment from 'moment'
import { list_building } from '../../constants/db-config'
import ExportCsvButton from '../../components/ExportExcel/ExportCsvButton'
import PrintPortal from '../../components/Print/PrintPortal';
import PrintBangKhachHang from '../../components/Print/PrintBangKhachHang';

export default {
    name:"bang-khach-hang",
    components: {
        ExportCsvButton,
        PrintPortal,
        PrintBangKhachHang
    },
    data() {
        return {
            loader: false,
            search:'',
            date_start: moment().startOf('month').format('YYYY-MM-DD'),
            date_end: new Date().toISOString().substr(0, 10),
            headers: [
                { text: "Số Phòng", align: "center", value: "room_id" },
                // { text: "Mã khách hàng", align: "center", value: "customer_id" },
                { text: "Họ và tên", align: "center", value: "name" },
                { text: "SDT", align: "center", value: "phone" },
                { text: "Số xe", align: "left", value: "motorbike" },
                { text: "Xe đạp", align: "center", value: "bike" },
                { text: "Máy giặt", align: "center", value: "is_wm" },
                { text: "Ngày dọn vào", align: "center", value: "date_in" },
            ],
            list_building: [
                ...list_building,
                {text: 'Tất cả', value: ''},
            ],
            list_search_type: [
                { text: 'Số phòng', value: 'roomId' },
                { text: 'Tên khách hàng', value: 'name' },
                // { text: 'Biển số xe', value: 'motorbike' }
            ],
            chosen_building: 'BN',
            items: [],
            loading: {
                submit: false
            },
            rowPerPage: [20,50,100,{"text":"Tất cả","value":-1}],
			export_csv: {
				loading: false,
				trigger: false,
				title: "",
				rows: []
            },
            print_table: false
        };
    },
    mounted() {
    },
    created(){
        this.getData()
    },
    watch: {
        chosen_building(){
            this.getData()
        },
        date_start: function(nv){
            this.getData()
        },
        date_end: function(nv){
            this.getData()
        }
    },
    methods: {
        getData: async function (){
            this.items = []
            this.loader = true
            const params = {
                building: this.chosen_building,
                dateStart: this.date_start,
                dateEnd: this.date_end
            }
            const query = buildParamQuery(params)
            let data = await api.searchCustomer(query)
            // let data = await api.getListCustomers()
            const room_arr = [];
            this.items = data.data.map(customer => {
                if (room_arr.indexOf(customer.room_id) == -1){
                    customer.show_room_id = true;
                    room_arr.push(customer.room_id);
                }
                return this.handleData(customer);
            })
            this.loader = false
        },
        handleData: function (data){
            // Xe đạp
            const bike = data.devicesInfo.find(dv => dv.type === 'B')
            data.bike = bike ? 'Có' : ''
            // Xe máy
            data.devicesInfo.forEach(device => {
                if (device.type === 'MB'){
                    if (data.motorbike){
                        data.motorbike += ", " + device.name.trim()
                    } else data.motorbike = device.name.trim()
                }
                if (device.type === "WM" && device.is_valid)
                    data.is_wm = true;
            })
            return data
        },
        exportCSV: function(){
			const rows = this.items.map(item => {
				return {
					"Tòa nhà": item.building,
					"Số phòng": item.room_id,
					"Họ và tên": item.name,
					"SDT": item.phone,
					"Số xe": item.motorbike,
					"Xe đạp": item.bike ?  'Có' : '',
					"Máy giặt": item.is_wm ?  'Có' : '',
					"Ngày dọn vào": formatTimeServer(item.date_in),
				}
			})
            this.export_csv.rows = rows;
            const date = new Date().toISOString().substr(0, 10)
			this.export_csv.title = "danh-sach-khach-hang-" + date;
			this.export_csv.trigger = !this.export_csv.trigger;
		}
    }
};
</script>
